<template>
  <div class="material-wrapper">
    <div class="currentImg">
      <img :src="mainImg">
    </div>
    <div class="img-box">
      <div class="img-group">
        <div class="img-item" v-for="(item, index) in materialsMin" :key="index">
          <img :src="item.img" alt="" @click="changeMainImg(item)">
        </div>
      </div>
    </div>
    <div class="footer">
      <p>图片尺寸：640px*300px</p>
      <p>格式：JPG，PNG，大小：150KB内。</p>
      <el-button type="primary" @click="dialogTableVisible = true">上传素材</el-button>
    </div>

    <el-dialog title="素材管理" :visible.sync="dialogTableVisible" class="material-govern" >
      <span class="sl-custom-file">
        <input type="button" value="添加素材" class="btn-file"/>
        <input type="file" class="ui-input-file" ref="imgUpload" @change="uploadMaterialImg"/>
      </span>
      <p class="upload-tip">图片尺寸：640px*300px、格式：JPG，PNG、大小：150KB内、最多100张，开启数量最多5个</p>
      <ul class="material-list">
        <li class="material-item" v-for="(item, index) in materials" :key="index">
          <div class="left">
            <img :src="item.BannerSrc" alt="">
          </div>
          <div class="right">
            <div class="form-controller">
              <label class="label">素材名称</label>
              <el-input v-model="item.Name" placeholder="请输入素材名称（15字内）" maxlength="15"></el-input>
            </div>
            <div class="form-controller require">
              <label class="label">广告描述</label>
              <el-input v-model="item.Desc" placeholder="请输入广告描述（15字内）" maxlength="15"></el-input>
            </div>
            <div class="form-controller require">
              <label class="label">按钮名称</label>
              <el-input v-model="item.BtnName" placeholder="请输入按钮名称（15字内）" maxlength="15"></el-input>
            </div>
            <div class="form-controller">
              <label class="label">开启状态</label>
              <el-switch
                v-model="item.openS"
                active-color="#5798d7"
                inactive-color="#ccc"
                @change="changeMaterialStatus(item)">
              </el-switch>
            </div>
          </div>
        </li>
      </ul>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeMaterialW(0)">取 消</el-button>
        <el-button type="primary" @click="closeMaterialW(1)">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>

export default {
  props: {
    materials: Array,
    materialsMin: Array
  },
  data () {
    return {
      aaa: 'abc',
      dialogTableVisible: false,
      mainImg: ''
    }
  },
  methods: {
    changeMainImg (imgEle) {
      if (imgEle.name === '默认') {
        return
      }
      this.mainImg = imgEle.img
    },
    // 上传素材图片
    uploadMaterialImg (e) {
      let file = e.target.files[0];
      if (file.size > 1000000) {
        this.$message.error('图片素材大小不能超过1M')
        return
      }
      if (file.type !== 'image/png' && file.type !== 'image/jpeg' && file.type !== 'image/gif') {
        this.$message.error('图片素材格式不正确')
        return
      }
      let param = new FormData()
      param.append('file', file, file.name)
      param.append('chunk', '0')
      let config = {
        headers:{'Content-Type':'multipart/form-data'}
      }
      this.$http.post('/IAD_Puton/UploadMateriaImg', param, config).then(res => {
        this.$emit('addMaterial', res.data)
        if (e.srcElement) {
          e.srcElement.value = ''
        } else {
          e.originalTarget.value = ''
        }
      })
    },
    // 关闭素材弹窗
    closeMaterialW (tag) {
      for(var i = 0; i < this.materials.length; i++){
        if (this.materials[i].Desc == '' || this.materials[i].BtnName == '') {
          this.$message.error('存在未填写的必填项')
          return
        }
      }
      let flag = false
      this.materials.forEach((item, index) => {
        if (item.openS) {
          flag = true
        }
      })
      if (!flag) {
        this.$message.error('素材至少开启一张')
        return
      }
      this.$emit('closeMaterialW', tag)
      this.dialogTableVisible = false
      
      if (this.materialsMin.length > 0) {
        this.mainImg = this.materialsMin[0].img
      }
    },
    // 切换素材状态
    changeMaterialStatus (data) {
      let openedMaterialCount = 0
      this.materials.forEach((item, index) => {
        if (item.openS) {
          openedMaterialCount++
        }
      })
      const tag = data.OpenState
      if (tag) {
        data.openS = false
        data.OpenState = 0
      } else {
        if(openedMaterialCount >= 6) {   // 记录当前数据的原始状态
          this.$message.error('素材最多可以开启5个')
          data.openS = false
          data.OpenState = 0
        } else {
          data.openS = true
          data.OpenState = 1
        }
      }
    }
  },
  mounted () {
    setTimeout(() => {
      if (this.materialsMin.length > 0) {
        this.mainImg = this.materialsMin[0].img
      }
    }, 1000)
  }
}
</script>

<style lang="scss" >
@import '../../../common/scss/color.scss';

.material-wrapper {
  width: 100%;
  height: 100%;
  border: 1px solid $borderColor;
  .currentImg {
    width: 100%;
    height: 260px;
    margin-bottom: 6px;
    position: relative;
    img {
      position: absolute;
      margin: auto;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      width: 99%;
      height: 97%;
      display: inline-block;
      vertical-align: middle;
    }
  }
  .img-box {
    width: 100%;
    overflow-x: auto;
    .img-group {
      overflow: hidden;
      .img-item {
        float: left;
        width: 91px;
        height: 60px;
        margin: 4px;
        &+.img-item {
          margin-right: 10px;
        }
        &:last-child {
          margin-right: 0;
        }
        img {
          cursor: pointer;
          width: 100%;
          height: 100%;
        }
      }
    }
  }
  .footer {
    position: relative;
    padding: 15px 10px;
    p {
      color: #999;
      height: 20px;
      line-height: 20px;
      font-size: 14px;
    }
    .el-button {
      position: absolute;
      right: 10px;
      top: 10px;
    }
  }
}

.material-govern {
  margin: 0 auto;
  width: 1300px;
  .el-dialog__header {
    text-align: center;
    font-weight: 700;
    border-bottom: 1px solid $borderColor;
  }
  .el-dialog__body {
    padding-top: 0;
    margin-top: -30px;
    .sl-custom-file {
      position: relative;
      top: -20px;
      display: inline-block;
      zoom: 1;
      cursor: pointer;
      overflow: hidden;
      vertical-align: middle;
    }
    .btn-file{
      background-color: #fff !important;
      color: $mainColor !important;
      width: 100px !important;
      height: 34px;
      border-radius: 0 !important;
    }
    .sl-custom-file .ui-input-file {
      position: absolute;
      right: 0;
      top: 0;
      _zoom: 30;
      font-size: 300px \9;
      height: 100%;
      _height: auto;
      opacity: 0;
      filter: alpha(opacity=0);
      -ms-filter: "alpha(opacity=0)";
      cursor: pointer;
    }
  }
  .el-dialog {
    width: 57%;
  }

  .upload-tip {
    font-size: #aaa;
  }
  .material-list {
    min-height: 181px;
    max-height: 560px;
    // height: 560px;
    overflow-y: auto;
    .material-item {
      border: 1px solid $borderColor;
      border-radius: 4px;
      margin-top: 4px;
      width: 98%;
      height: 179px;
      display: flex;
      justify-content: space-between;
      .left {
        width: 47%;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .right {
        width: 51%;
        .form-controller {
          margin-top: 9px;
          margin-left: 10px;
          &.require::before {
            content: '*';
            color: red;
            margin-left: -8px;
            font-size: 18px;
            position: relative;
            top: 4px;
          }
        }
        .el-input {
          width: 243px;
        }
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/public/edit-plan-sub/multiMateial.vue